import type { TUniversity } from '../../types';
import type { FC } from 'react';
import UniversityItem from './components/university-item';
import UniversityAssigneeListCell from '../../tables/cells/university-assignee-list-cell';
import type { TSubmission } from '@src/shared/types/submission';
import { LabelAction } from '../../pages/list/actions/label-action';
import { cn } from '@src/design-system/helpers';

const BasicInformation: FC<{ university: TUniversity; modal?: boolean }> = ({
  university,
  modal = true,
}) => {
  return (
    <div
      className={cn(
        'space-y-4 p-4 m-4 mt-0 bg-white rounded-xl',
        !modal && 'm-0 p-0 pt-4'
      )}
    >
      <p className='font-semibold text-gray-800'>Basic Information</p>
      <div
        className={cn(
          'flex flex-col gap-4',
          !modal && 'flex-row items-start space-x-12 gap-y-0'
        )}
      >
        <UniversityItem
          label='Account Manager'
          value={
            <UniversityAssigneeListCell
              submission={{
                ...(university as unknown as TSubmission),
                id: university?.id,
              }}
            />
          }
        />
        <UniversityItem
          label='Labels'
          value={
            <LabelAction
              labels={university?.labels ?? []}
              id={university?.id}
            />
          }
        />
      </div>
    </div>
  );
};

export default BasicInformation;
